import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import '../../styles/strategicIssues.css';

import IssueImage1 from '../../../assets/forpasi-isu-1.jpeg';
import IssueImage2 from '../../../assets/forpasi-isu-2.jpg';
import IssueImage3 from '../../../assets/forpasi-isu-3.jpg';
import BappenasImage from '../../../assets/bappenas.jpg';
import InvestasiImage from '../../../assets/investasi.JPG';
import SampahImporImage from '../../../assets/sampah impor.jpg';

const StrategicIssue = () => {
  const { language } = useLanguage();
  const [userEmail, setUserEmail] = useState("");
  const [emailSubmitted, setEmailSubmitted] = useState(false);

  const images = [IssueImage1, IssueImage2, IssueImage3, IssueImage1, IssueImage1];

  const content = {
    id: [
      {
        title: "ISU TATA KELOLA: Persampahan nasional masih sporadis",
        desc: "Pengelolaan sampah di Indonesia dinilai masih bersifat sporadis. FORPASI mendorong rekomendasi kebijakan untuk meningkatkan tata kelola persampahan nasional agar lebih terstruktur.",
        note: "Unduh rekomendasi kebijakan FORPASI",
        pdfLink: "/pdf/rekomendasi-kebijakan.pdf",
        btnText: "Unduh Rekomendasi"
      },
      {
        title: "Segera Bentuk BPSN (Badan Pengelolaan Sampah Nasional)",
        desc: "FORPASI mengusulkan pembentukan BPSN untuk menangani persoalan persampahan secara menyeluruh di Indonesia.",
        img: images[1]
      },
      {
        title: "ISU KEBERPIHAKAN POLITIK: Tingkatkan APBD untuk sampah, minimal 2%",
        desc: "Anggaran daerah rata-rata masih di 0.6% APBD. Hal ini mencerminkan keberpihakan politik yang masih minim sehingga banyak terjadi kasus darurat sampah di berbagai titik di Indonesia.",
        img: BappenasImage
      },
      {
        title: "Isu Sampah Pariwisata",
        desc: "Sampah di kawasan pariwisata berpotensi lebih tinggi dibandingkan perkotaan. Diperlukan tata kelola dan edukasi yang lebih baik untuk dampak berkelanjutan.",
        img: images[2]
      },
      {
        title: "Kebersihan adalah Investasi, Sampah adalah Tanggung Jawab",
        desc: "FORPASI menekankan bahwa kebersihan merupakan bentuk investasi jangka panjang bagi masyarakat dan lingkungan, dan sampah merupakan  tanggung jawab. Hal ini sesuai dengan penyampaian tokoh persampahan nasional, ratu sampah, dan Braintrust FORPASI, Almarhumah Ir. Sri Bebassari, M.Si.",
        img: InvestasiImage
      },
      {
        title: "Geopolitik Persampahan Nasional dan Internasional",
        desc: "Isu persampahan juga berkaitan dengan geopolitik di tingkat nasional dan internasional yang perlu dikelola secara strategis.Sumber: Kumparan, 2019",
        img: SampahImporImage
      }
    ],
    en: [
      {
        title: "National Waste Management is Still Sporadic",
        desc: "Waste management in Indonesia is still considered sporadic. FORPASI advocates policy recommendations to improve the national waste management system.",
        note: "FORPASI's response to the sporadic waste management issue:",
        pdfLink: "/pdf/policy-recommendations.pdf",
        btnText: "Download Recommendations"
      },
      {
        title: "Establish the National Waste Management Agency",
        desc: "FORPASI proposes the establishment of BPSN to comprehensively address Indonesia's waste problems.",
        img: images[1]
      },
      {
        title: "POLITICAL BIAS ISSUE: Increase APBD for waste to at least 2%",
        desc: "Regional budgets average only 0.6% of APBD. This reflects a low level of political bias, resulting in many waste emergency cases across Indonesia.",
        img: BappenasImage
      },
      {
        title: "Tourism Waste Issue",
        desc: "Waste in tourism areas is potentially higher than in urban areas. Better management and visitor education are needed for sustainable impact.",
        img: images[2]
      },
      {
        title: "Cleanliness is an Investment, Waste is a Responsibility",
        desc: "FORPASI emphasizes that cleanliness is a long-term investment for society and the environment.",
        img: images[3]
      },
      {
        title: "National and International Waste Geopolitics",
        desc: "Waste issues are also linked to national and international geopolitics that need to be managed strategically.",
        img: images[4]
      }
    ]
  };

  const issues = content[language] || content.id;

  const handleSubmitEmail = (e) => {
    e.preventDefault();
    if (userEmail) {
      setEmailSubmitted(true);
    }
  };

  return (
    <section className="strategic-section">
      <div className="strategic-container">
        <h2 className="strategic-title">
          {language === 'id' ? "" : "Strategic Issues"}
        </h2>
        {issues.map((issue, idx) => (
          <div key={idx} className={`strategic-item fade-in ${idx % 2 === 0 ? "left" : "right"}`}>
            <div className="strategic-text">
              <h1>{issue.title}</h1>
              <p>{issue.desc}</p>
              {issue.note && <p className="strategic-note">{issue.note}</p>}

              {/* Kalau ada PDF link, ganti logic jadi input email dulu */}
              {issue.pdfLink && (
                <>
                  {!emailSubmitted ? (
                    <form onSubmit={handleSubmitEmail} className="email-form">
                      <input
                        type="email"
                        placeholder={language === 'id' ? "Masukkan email kamu" : "Enter your email"}
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.target.value)}
                        required
                      />
                      <button type="submit" className="strategic-btn">
                        {issue.btnText}
                      </button>
                    </form>
                  ) : (
                    <a href={issue.pdfLink} className="strategic-btn" download>
                      {language === 'id' ? "Download Sekarang" : "Download Now"}
                    </a>
                  )}
                </>
              )}
            </div>
            <div className="strategic-image">
              <img src={issue.img || images[idx]} alt={issue.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StrategicIssue;
